/*
    * Type Scripts Methods And Events
*/
import Vue from "vue";
import Axios from 'axios';
import * as moment from 'moment-timezone';
import * as _ from 'lodash';
import { EditProfile } from "../../../../store/modules/App/Assets/EditProfile/types";
import { Component } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { http } from '@/shared/https';
import AuthService from '@/services/auth.service';
const auth = new AuthService();
const namespace: string = "RootEditProfile";

/*
    * Component's properties and events
*/
@Component({
    components: {
    }
})

export default class EditProfileComponent extends Vue {
    @State("RootEditProfile") profile!: EditProfile;
    @Getter("_appSignOutComponent", { namespace: "RootApp" })
    signOutComponents: any;

    /*
        * The mounted() method gives you access to templates and enables interaction with the DOM.
    */
    mounted() {
        let context = this.profile, self = this;
        context.container = true;

        //#.SignOut button translator.
        context.signOut = (self.$vuetify.lang.locales[self.$vuetify.lang.current][context.signOut] || context.signOut).toString();

        //#.Profile item translator.
        if (context.content) {
            // @ts-ignore
            _.forOwn(context.content, function (key, val) {
                if (key.title) {
                    if (!key._title)
                        key._title = key.title;

                    key.title = self.$t(key._title) || key._title;
                }
            });
        }

        //#.Get current user information.
        return http.get('/api/Dashboard/GetUserInfo').then(record => {
            if (record.data.Result == 'OK') {
                context.user.name = record.data.User[0].UserName;
                context.user.email = record.data.User[0].UserEmail;
                context.user.avatar = record.data.User[0].UserImage;
                context.user.acronym = record.data.User[0].Acronym;
                context.user.date = this.$services.dateFormat.dateCommonFormat(record.data.Date, 'DD/MM/YYYY'); // moment(record.data.Date).format('ll');
            }
        });
    }

    /*
        * Application logout event
    */
    _profileSignOut(state, payload) {
        this.signOutComponents;
     
        //#.Reset location storage information 
        localStorage.setItem('vueAppMenuTab', '');
        localStorage.setItem('vueAppModule', '');
        localStorage.setItem('filterBy', '{}');

        //#.LogOut action are triggered with the method.
        auth.logout();
    }

    _profileEdit(state, payload) {
        window.location.href = "/profile";
        // this.$router.push({
        //     name: "profile",
        //     // query: { appid: proposalId }
        //   });
    }

    /*
        * Change default language
    */
    _resetDefaultLanguage(value) {
        // @ts-ignore
        let context = this.$store.state.dashboard, self = this,
        root = this.$store.state.RootApp;
        this.$vuetify.lang.current = value;
        
        //#.Apply translation to messages
        if (this.$store.state.keyTranslator) {
            // @ts-ignore
            if (!this.profile._signOut) {
                // @ts-ignore
                this.profile._signOut = this.profile.signOut;
            }

            // @ts-ignore
            this.profile.signOut = (this.$vuetify.lang.locales[this.$vuetify.lang.current][this.profile._signOut] || this.profile._signOut).toString();

            if (this.profile.content) {
                // @ts-ignore
                _.forOwn(this.profile.content, function (key, val) {
                    if (key.title) {
                        if (!key._title)
                            key._title = key.title;

                        key.title = self.$vuetify.lang.locales[self.$vuetify.lang.current][key._title] || key._title;
                    }
                });
            }        

            if (root.buttons) {
                _.forOwn(root.buttons.btn, function (key, val) {
                    if (key.tooltip) {

                        if (!key._tooltip)
                            key._tooltip = key.tooltip;

                        key.tooltip = self.$vuetify.lang.locales[self.$vuetify.lang.current][key._tooltip] || key._tooltip;
                    }
                });

                if (!root.about._title)
                    root.about._title = root.about.title;

                if (!root.about._copyRight)
                    root.about._copyRight = root.about.copyRight;

                root.about.copyRight = self.$vuetify.lang.locales[self.$vuetify.lang.current][root.about._copyRight] || root.about._copyRight;
                root.about.title = self.$vuetify.lang.locales[self.$vuetify.lang.current][root.about._title] || root.about._title;
            }

            if (context.renderComponent) {
                _.forOwn(context.messages, function (key, val) {
                    if (val.indexOf('_') == -1 && !context.messages["_" + val])
                        context.messages["_" + val] = key;

                    if (val.indexOf('_') == -1)
                        context.messages[val] = self.$vuetify.lang.locales[self.$vuetify.lang.current][context.messages["_" + val]] || context.messages["_" + val];
                });

                context.cards.filter(x => x).forEach(key => {
                    let componentName = key.charAt(0).toLowerCase() + key.slice(1).replace('Component', '');
                    componentName = componentName + 'Index';
                    let components = this.$store.state, header = [];

                    // @ts-ignore
                    _.forOwn(components[componentName].fields, function (key, val) {
                        if (key.primaryKey != true && key.parent != true && key.list != false && key.type != 'Hidden' && key.text) {
                            if (!key.orgTitle)
                                key.orgTitle = key.title;

                            key.text = self.$vuetify.lang.locales[self.$vuetify.lang.current][key.orgTitle] || key.orgTitle;
                            key.title = key.text;
                            // @ts-ignore
                            header.push(key);
                        }
                    });
                    components[componentName].headers = header;
                });
            }

            context.renderComponent = false;

            this.$nextTick(() => {
                //#. Add the component back in
                context.renderComponent = true;
            });
        }
    }
}